import React from 'react';
import Menu from './Components/menu.jsx';
import Banner from './Components/banner.jsx';
import Filiar from './Components/filiar.jsx';

function Site(){
    return <div>
           <Menu/>
           <Banner/>
        </div>;
  }

  export default Site;